import { Route, Routes } from "react-router-dom";
import "./App.css";
import Contact from "./pages/Contact/Contact";
import Home from "./pages/Home/Home";
import Projects from "./pages/Projects/Projects";
import Navbar from "./components/NavBar/Navbar";
import Aboutme from "./pages/Aboutme/Aboutme";
import { ToastContainer } from "react-toastify";
import Blog from "./pages/Blog/Blog";
import ProjectDetails from "./pages/ProjectDetails/ProjectDetails";
import Services from "./pages/Services/Services";

function App() {
  return (
    <div className="font-mono text-neutral">
      <Navbar>
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/projects" element={<Projects />}></Route>
          <Route path="/projects/:id" element={<ProjectDetails />}></Route>
          <Route path="/contact" element={<Contact />}></Route>
          <Route path="/aboutme" element={<Aboutme />}></Route>
          <Route path="/services" element={<Services />}></Route>
          <Route path="/blog" element={<Blog />}></Route>
        </Routes>
        <ToastContainer />
      </Navbar>
    </div>
  );
}

export default App;
